const Client = require("discord-oauth2-api")
const client = new Client({
  clientID: '1143538313320464437',
  clientSecret: 'c3WEF8-4StyC_QahcZAeoftysFSN3-XT',
  scopes: ['identify', 'guilds'],
  redirectURI: 'https://geribildirim.vercel.app/'
})

export { client }